import React from "react";
import PropTypes from "prop-types";
import FormInput from "Common/Custom/FormInput";
import FormSubmitButton from "Common/Custom/FormSubmitButton";
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";
import Switch from "Common/Custom/Switch";
import FormTextarea from "Common/Custom/FormTextarea";

const AddSupplierForm = ({
  fields = [],
  values = {},
  errors = {},
  handleChange = () => { },
  handleSubmit = () => { },
  loading = false,
}) => {
  const renderField = (field) => {
    if (field.type === "switch") {
      return (
        <Switch
          key={field.name}
          field={field}
          values={values[field.name]}
          handleChange={handleChange}
          ValueOne="1"
          ValueTwo="0"
          LabelOne="Active"
          LabelTwo="Inactive"
        />
      );
    }

    if (field.type === "texttextarea") {
      return (
        <FormTextarea
          key={field.name}
          field={field}
          value={values[field.name] ?? ""}
          handleChange={handleChange}
          error={errors[field.name]}
          
        />
      );
    }

    return (
      <FormInput
        key={field.name}
        field={field}
        value={values[field.name] ?? ""}
        handleChange={handleChange}
        error={errors[field.name]}
      />
    );
  };

  return (
    <PageBody
      headerchildren={<HeadingOne>Add Supplier</HeadingOne>}
      onSubmit={handleSubmit}
    >
      {fields.map(renderField)}

      <FormSubmitButton
        label="Create"
        loading={loading}
        colSize="col-12"
        align="end"
      />
    </PageBody>
  );
};

AddSupplierForm.propTypes = {
  fields: PropTypes.array,
  values: PropTypes.object,
  errors: PropTypes.object,
  handleChange: PropTypes.func,
  handleSubmit: PropTypes.func,
  loading: PropTypes.bool,
};

export default AddSupplierForm;
